// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import GeolocationInputController from "./geolocation_input_controller"
application.register("geolocation-input", GeolocationInputController)

import LeafletOverviewController from "./leaflet_overview_controller"
application.register("leaflet-overview", LeafletOverviewController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)
